"use client";
import React from 'react';

export const FleetThemeContext = React.createContext<'dark' | 'light'>('dark');

export function useFleetTheme(): 'dark' | 'light' {
  return React.useContext(FleetThemeContext);
}


